export const GET_USER = 'GET_USER'
export const GET_TOKEN = 'GET_TOKEN'